<template>
    <div>
        <div class="profileContainer">
            <div class="fixed-header">
                <HeadCard />
            </div>
            <div class="profileContainer">
                <div class="content">
                    <div style="margin: 10px;margin-top: 2rem;">
                        <VipCard />
                    </div>
                    <div style="margin: 0 10px;">
                        <MenuCard :isSupportChatMenu="true" />
                        <MenuCard />
                    </div>
                </div>
            </div>
            <div style="padding-top: 70px;">
                <MainFooter :itemData="userStore.footerComponent" :active-footer="4" />
            </div>
            </div>
        </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import HeadCard from './components/headCard.vue'
import VipCard from './components/vipCard.vue'
import MenuCard from './components/menuCard.vue'
import MainFooter from '../components/common/mainFooter.vue'
import { ProfilePoupData } from '@/view/profile/supportScript'
import { useUserStore } from '@/stores/user';
const userStore = useUserStore()

const props = defineProps<{
    dataSet: ProfilePoupData
}>()

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const emits = defineEmits(['close', 'clickBanner', 'update:show'])


const close = () => {
    emits('close')
}
const clickBanner = () => {
    emits('clickBanner')
}

const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};
defineExpose({
    open,
    close
})

</script>
<style scoped>
.profileContainer {
    /*background: #003534;
     min-height: 100vh; */
}

.fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
}

.profileContainer {
    padding-top: 120px;
}
</style>